import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { Spacing } from 'styles/theme/Tema';
import { TextoPequeno } from 'view/component/Tipografia/Texto';
import { centralizadoVerticalmente } from 'styles/Utilitarios';
import { LimparBotaoPequeno } from 'view/component/Botao/LimparBotaoPequeno';


interface FiltroResumoItemEsqueletoProps<T extends object> {
  /** Nome do campo */
  rotulo: string;

  /** Identificador do campo (nome do atributo) */
  identificador: keyof T;

  onRemoverClick: (chave: keyof T) => void;

  children?: ReactNode;
}

interface FiltroResumoItemProps<T extends object> extends FiltroResumoItemEsqueletoProps<T> {
  filtros: T;

  /** Tratamento que pega os valores e transforma-os em elementos */
  tratamento: (elementos: any|any[]) => any;
}


export const FiltroResumoItem = <T extends object>({filtros, onRemoverClick: onRemoverFiltro, rotulo, identificador, tratamento}: FiltroResumoItemProps<T>) => {
  if (filtros?.[identificador] === undefined) {
    return null;
  }

  const elementos = filtros?.[identificador];
  const elementosFiltrados = asArray(elementos).filter(it => it !== '')
  
  if (elementosFiltrados.length === 0) {
    return <></>
  }

  const valor = tratamento(elementosFiltrados);
  return <FiltroResumoItemEsqueleto rotulo={rotulo} onRemoverClick={onRemoverFiltro} identificador={identificador}>
    {valor}
  </FiltroResumoItemEsqueleto>
}

export const FiltroResumoItemEsqueleto = <T extends object>({onRemoverClick: onRemoverFiltro, rotulo, identificador, children}: FiltroResumoItemEsqueletoProps<T>) => {
  const onClick = () => onRemoverFiltro(identificador);

  return <ResumoOpcaoContainer>
    <ResumoOpcaoTitulo as="div">
      {rotulo}
      <RemoverFiltroBotao onClick={onClick} />
    </ResumoOpcaoTitulo>
    <ResumoOpcaoValor>{children}</ResumoOpcaoValor>
  </ResumoOpcaoContainer>
}

function asArray(elemento: any|any[]) {
  return Array.isArray(elemento) ? elemento : [elemento];
}

const ResumoOpcaoTitulo = styled(TextoPequeno)`
  margin-bottom: ${Spacing.unit/4}px;
`;

const ResumoOpcaoValor = styled.div`
  ${centralizadoVerticalmente};
  max-height: ${Spacing.unit*4}px;
`;

const ResumoOpcaoContainer = styled.div`
  min-width: ${Spacing.unit * 10}px;
  margin: 0 ${Spacing.unit/2}px;
  padding: ${Spacing.unit/2}px;
  position: relative;
`;

export const ItemResumoVazio = styled(ResumoOpcaoContainer)`
  font-style: italic;
  color: ${p => p.theme.texto.enfase_baixa};
`;


interface RemoverFiltroBotaoProps {
  onClick: () => void;
}

export const RemoverFiltroBotao: FC<RemoverFiltroBotaoProps> = ({onClick}) => {
  return <LimparBotaoPequeno onClick={onClick} title="Remover filtro" />
}
